export type ContactAttachment = {
  fileName: string;
  contentType: string;
  contentBase64: string;
};

export type ContactPayload = {
  name: string;
  email: string;
  subject: string;
  message: string;
  attachments?: ContactAttachment[];
};

export type ContactResponse = {
  success?: boolean;
  message?: string;
  reference?: string;
};

export async function submitContact(payload: ContactPayload): Promise<{
  ok: boolean;
  status: number;
  data?: ContactResponse;
}> {
  const res = await fetch("/api/contact", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  let data: ContactResponse | undefined;
  try {
    data = (await res.json()) as ContactResponse;
  } catch {
    data = undefined;
  }
  return { ok: res.ok, status: res.status, data };
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result !== "string") {
        reject(new Error("Datei konnte nicht gelesen werden."));
        return;
      }
      const separatorIndex = reader.result.indexOf(",");
      resolve(separatorIndex >= 0 ? reader.result.slice(separatorIndex + 1) : reader.result);
    };
    reader.onerror = () => {
      reject(reader.error ?? new Error("Datei konnte nicht verarbeitet werden."));
    };
    reader.readAsDataURL(file);
  });
}

export async function buildContactAttachments(files: File[]): Promise<ContactAttachment[]> {
  return Promise.all(
    files.map(async (file) => ({
      fileName: file.name,
      contentType: file.type || "application/octet-stream",
      contentBase64: await fileToBase64(file),
    }))
  );
}
